import { COVERGO_SAAS_DEV } from "../consts.js"

export const p_tenant_31_dev = {
	"p-tenant-31-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "p_tenant_31_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
